import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styles from './courtSchedular.scss';
import useCloseAnimation from '../../../components/hooks/useCloseAnimation';

const CourtDeskSidePanel = ({
    className,
    allowCloseOnClickOutside,
    closeSideBar,
    children,
    isVisible,
    onClose,
}) => {
    const { isClosed, isClosing } = useCloseAnimation({ isVisible, onClose });
    const [childrenMounted, setChildrenMounted] = useState(false);

    useEffect(() => {
        if (isClosed) {
            setChildrenMounted(false);
            return undefined;
        }
        const t = setTimeout(() => {
            setChildrenMounted(true);
        }, 0);
        return () => {
            clearTimeout(t);
        };
    }, [isClosed]);

    const handleClose = () => {
        closeSideBar();
    };

    const onClickOutsideSideBar = () => {
        if (allowCloseOnClickOutside) {
            handleClose();
        }
    };

    if (isClosed) {
        return null;
    }

    const animationClass = isClosing ? styles.closing : styles.opening;

    return (
        <div className={`${styles.courtDeskSideBar} ${className}`}>
            <div className="flex-1" onClick={onClickOutsideSideBar} />
            <div className={`${styles.sidebar} ${animationClass}`}>
                {childrenMounted && children}
            </div>
        </div>
    );
};

CourtDeskSidePanel.propTypes = {
    className: PropTypes.string,
    allowCloseOnClickOutside: PropTypes.bool,
    closeSideBar: PropTypes.func,
    children: PropTypes.node.isRequired,
    isVisible: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
};

CourtDeskSidePanel.defaultProps = {
    className: '',
    allowCloseOnClickOutside: false,
    closeSideBar: () => { },
    onClose: null,
};

export default CourtDeskSidePanel;
